import { IGetContaReceberByIdUseCase } from "../../../presentation/useCases/read/get_conta_receber_by_id_use_case";
import { ContaReceber } from "../../models/conta_receber";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * GetContaReceberByIdUseCase
 */

export class GetContaReceberByIdUseCase implements IGetContaReceberByIdUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async getContaReceberById(idContaReceber: number): Promise<ContaReceber> {
    return await this.repository.getContaReceberById(idContaReceber)

  }
}
